export const isFormValid = (state) => {
  const { vehicle, driver, contractor, quote } = state;

  const vehicleValid =
    Object.values(vehicle.validValues || {}).length > 0 &&
    Object.values(vehicle.validValues).every(Boolean);

  const requiredDriverFields = ["nombres", "genero", "fechaNacimiento", "codigoPostal"];
  const driverValid = requiredDriverFields.every(
    (field) => driver.validValues?.[field] === true
  );

  const requiredContractorFields = ["correoElectronico", "telefonoMovil"];
  const contractorValid = requiredContractorFields.every(
    (field) => contractor.validValues?.[field] === true
  );
  const termsValid =
    Object.values(quote.termsAndConditions || {}).every(Boolean);
    
  return vehicleValid && driverValid && contractorValid && termsValid;
};